import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapPoiPopupComponent } from './map-poi-popup.component';
import {DxFormModule, DxTabsModule} from 'devextreme-angular';
import {UserDomainsChooserModule} from '../../user-domains/user-domains-chooser/user-domains-chooser.module';



@NgModule({
  declarations: [MapPoiPopupComponent],
  imports: [
    CommonModule,
    DxTabsModule,
    DxFormModule,
    UserDomainsChooserModule
  ],
  exports: [MapPoiPopupComponent]
})
export class MapPoiPopupModule { }
